module.exports = __webpack_public_path__ + "img/logo_grupovia.5b8c7b99.png";